import { customBaseQuery } from '@app/services/rtkQuery/baseQuery';
import type { IBaseQueryParams } from '@app/services/rtkQuery/baseQuery';

import type { BaseQueryApi } from '@reduxjs/toolkit/query';

export const createApiBaseQuery =
  (resource: string, options?: Pick<IBaseQueryParams, 'isBookHost'>) =>
  ({ url, ...props }: IBaseQueryParams, api: BaseQueryApi) =>
    customBaseQuery(
      {
        url: `${resource}/${url}`,
        ...options,
        ...props,
      },
      api
    );
